function parseMadesaQuickViewI18n() {
  const defaults = {
    cart_add_failed: "Could not add to cart",
    toast_add_error: "Could not add the product to your cart. Please try again.",
  };
  const el = document.getElementById("madesa-quick-view-i18n");
  if (!el || !String(el.textContent || "").trim()) {
    return defaults;
  }
  try {
    const parsed = /** @type {Record<string, unknown>} */ (JSON.parse(el.textContent));
    /** @type {typeof defaults} */
    const out = Object.assign({}, defaults);
    let pk;
    for (pk in parsed) {
      if (
        Object.prototype.hasOwnProperty.call(parsed, pk) &&
        Object.prototype.hasOwnProperty.call(defaults, pk) &&
        parsed[pk] != null &&
        parsed[pk] !== ""
      ) {
        out[/** @type {keyof typeof defaults} */ (pk)] = String(parsed[pk]);
      }
    }
    return out;
  } catch (e) {
    return defaults;
  }
}

const QV = parseMadesaQuickViewI18n();

class ProductQuickView extends HTMLElement {
  constructor() {
    super();

    this.handle = this.getAttribute("data-handle");
    this.onClick = this.handleQuickView.bind(this);
    this.onKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.onClick);
    this.addEventListener("keydown", this.onKeydown);

    if (!this.hasAttribute("role")) {
      this.setAttribute("role", "button");
    }

    if (!this.hasAttribute("tabindex")) {
      this.setAttribute("tabindex", "0");
    }
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
    this.removeEventListener("keydown", this.onKeydown);
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.handleQuickView(event);
    }
  }

  /**
   * @param {Event} event
   */
  handleQuickView(event) {
    event.preventDefault();

    if (!this.handle) return;

    this.renderProduct(this.handle);
  }

  /**
   * @param {string} handle
   */
  renderProduct(handle) {
    const sectionTarget = "#shopify-section-bf-quick-view";

    fetch(`/products/${encodeURIComponent(handle)}?section_id=bf-quick-view`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const targetElement = document.querySelector(sectionTarget);
        const sourceElement = html.querySelector(sectionTarget);

        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      })
      .then(() => {
        const quickViewSection = document.querySelector(sectionTarget);
        const quickViewElement = quickViewSection?.querySelector("quick-view");

        if (!quickViewSection || !quickViewElement) return;

        quickViewSection.classList.add("active");
        quickViewElement.setAttribute("aria-hidden", "false");
        document.body.classList.add("quick-view-open");
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

if (!customElements.get("button-quick-view")) {
  customElements.define("button-quick-view", ProductQuickView);
}

class QuickView extends HTMLElement {
  constructor() {
    super();

    this.productInput = /** @type {HTMLInputElement | null} */ (this.querySelector("[data-product-id]"));
    this.productID = this.productInput?.value;
    this.btnAddCart = /** @type {HTMLButtonElement | null} */ (this.querySelector("[data-product-add-cart]"));
    this.variants = this.querySelector("[data-variants]");

    this.onClick = this.handleClick.bind(this);
    this.onVariantChange = this.handleVariantChange.bind(this);
    this.onEsc = this.handleEsc.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.onClick);
    this.variants?.addEventListener("change", this.onVariantChange);
    document.addEventListener("keydown", this.onEsc);

    if (this.btnAddCart) {
      this.btnAddCart.addEventListener("click", this.addCart.bind(this));
    }
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
    this.variants?.removeEventListener("change", this.onVariantChange);
    document.removeEventListener("keydown", this.onEsc);
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleEsc(event) {
    if (event.key === "Escape") {
      this.closeQuickView();
    }
  }

  /**
   * @param {MouseEvent} event
   */
  handleClick(event) {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest("[data-close-quick-view]")) {
      this.closeQuickView();
    }
  }

  /**
   * @param {Event} event
   */
  handleVariantChange(event) {
    if (!(event.target instanceof HTMLElement)) return;

    const variantInput = /** @type {HTMLInputElement | HTMLSelectElement | null} */ (
      event.target.closest("[name='id']")
    );

    if (!variantInput) return;

    this.productID = variantInput.value;
    if (this.productInput) {
      this.productInput.value = variantInput.value;
    }
  }

  closeQuickView() {
    const section = this.closest("#shopify-section-bf-quick-view");

    section?.classList.remove("active");
    this.setAttribute("aria-hidden", "true");
    document.body.classList.remove("quick-view-open");
  }

  cartUpdate() {
    const win = /** @type {any} */ (window);
    const cartUrl = win.routes?.cart_url || "/cart";

    fetch(`${cartUrl}?section_id=bf-minicart`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const targetElement = document.querySelector("#shopify-section-bf-minicart");
        const sourceElement = html.querySelector("#shopify-section-bf-minicart");

        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  addCart() {
    if (!this.productID || !this.btnAddCart) return;
    if (this.btnAddCart.hasAttribute("data-project-add-cart")) return;

    const brinde = window.MadesaBrinde;
    const isBrindeVariant = brinde?.isBrindeVariant?.(this.productID);

    if (isBrindeVariant && brinde?.isAddLocked?.()) {
      brinde.showError("already_in_cart");
      return;
    }

    this.btnAddCart.setAttribute("disabled", "disabled");

    const runAdd = () => {
      const data = {
        items: [
          {
            id: this.productID,
            quantity: 1,
            ...(isBrindeVariant ? { properties: { _brinde: "true" } } : {}),
          },
        ],
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((json) => {
          if (json.status && json.status >= 400) {
            throw new Error(json.description || QV.cart_add_failed);
          }

          if (isBrindeVariant) {
            brinde?.releaseBrindeAddSuccess?.(undefined, this.productID);
          }

          this.cartUpdate();
          this.closeQuickView();

          const minicartToggle = /** @type {HTMLInputElement | null} */ (
            document.querySelector("#toggle-minicart")
          );
          if (minicartToggle) {
            minicartToggle.checked = true;
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          if (isBrindeVariant) {
            brinde?.releaseBrindeAddFailed?.();
          }
          const message =
            error instanceof Error && error.message ? error.message : QV.toast_add_error;
          document.dispatchEvent(
            new CustomEvent("toast:show", {
              detail: { message, type: "error" },
            }),
          );
        })
        .finally(() => {
          if (!brinde?.isAddLocked?.()) {
            this.btnAddCart?.removeAttribute("disabled");
          }
        });
    };

    if (isBrindeVariant && brinde?.confirmBrindeAdd) {
      if (!brinde.tryBeginBrindeAdd()) {
        brinde.showError("already_in_cart");
        return;
      }

      brinde
        .confirmBrindeAdd({ variantId: this.productID })
        .then((result) => {
          if (!result.ok) {
            brinde.showError(result.reason || "already_in_cart");
            if (!brinde.isAddLocked()) {
              this.btnAddCart?.removeAttribute("disabled");
            }
            return;
          }
          runAdd();
        })
        .catch(() => {
          brinde?.releaseBrindeAddFailed?.();
          if (!brinde?.isAddLocked?.()) {
            this.btnAddCart?.removeAttribute("disabled");
          }
        });
      return;
    }

    runAdd();
  }
}

if (!customElements.get("quick-view")) {
  customElements.define("quick-view", QuickView);
}
